export const routes = (parentName) => {
  return [
    {
      path: "initial",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-InitialCost`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-InitialCost-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "special",
          name: `${parentName}-InitialCost-List-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-InitialCost-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "InitialCost-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "InitialCost-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
